module.exports = __webpack_public_path__ + "static/media/logo-wordmark.9b012ceb.png";